import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.5 7.98438H7.51M7.5 3.98438H12.5C13.012 3.98438 13.524 4.17937 13.914 4.57037L20.914 11.5704C21.2889 11.9454 21.4996 12.454 21.4996 12.9844C21.4996 13.5147 21.2889 14.0233 20.914 14.3984L13.914 21.3984C13.5389 21.7733 13.0303 21.9839 12.5 21.9839C11.9697 21.9839 11.4611 21.7733 11.086 21.3984L4.086 14.3984C3.9 14.2129 3.75249 13.9925 3.65192 13.7498C3.55136 13.5072 3.49973 13.247 3.5 12.9844V7.98438C3.5 6.92351 3.92143 5.90609 4.67157 5.15595C5.42172 4.4058 6.43913 3.98438 7.5 3.98438Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }